import * as React from 'react';

import Handshake56 from './Handshake56';

export const handshake56 = () => <Handshake56 />;

export default {
    title: 'Illustration|Handshake56',
    component: Handshake56,
    parameters: {
        notes: "`import Handshake56 from 'box-ui-elements/es/illustration/Handshake56';`",
    },
};
